import { Trans } from 'react-i18next'
import { Alert, Box, Flex, Typography } from '@percent/lemonade'
import { CONTACT_CUSTOMER_SERVICE_FORM_LINK } from '@percent/cause-dashboard/constants/support'

type BookingNoticeProps = {
  onSupportLinkClick: () => void
}

// Says what the call is for before the user books, and points support queries to the
// support form: they were filling the sales calendar with calls specialists can't help with.
export const BookingNotice = ({ onSupportLinkClick }: BookingNoticeProps) => (
  <Box w="100%" data-testid="grant-advisory-booking-notice">
    <Alert variant="info" descriptionVariant="div">
      <Flex direction="column" gap={8}>
        <Typography variant="small">
          <Trans i18nKey="grantAdvisoryBooking.notice.about" components={{ b: <strong /> }} />
        </Typography>
        <Typography variant="small">
          <Trans
            i18nKey="grantAdvisoryBooking.notice.support"
            components={{
              a: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content -- Trans fills in the link text
                <a
                  href={CONTACT_CUSTOMER_SERVICE_FORM_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onSupportLinkClick}
                />
              )
            }}
          />
        </Typography>
      </Flex>
    </Alert>
  </Box>
)
